<template>
  <ControlUnit :title="$t('control.panel.widget_button_animation')">
    <label class="input-checkbox">
      <input
        v-model="widget_button_animation"
        type="checkbox"
        class="input-checkbox__input"
      />
      <span>{{ $t('control.panel.widget_button_animation') }}:</span>
    </label>
  </ControlUnit>
</template>

<script>
import useStateController from './useStateController';
import ControlUnit from "@/views/Control/ControlPanel/ControlUnit/ControlUnit";
import {useStore} from "vuex";
import {computed, onMounted} from "vue";
import useRouteController from "@/views/Control/ControlPanel/ControlUnit/useRouteController";
import {runAllWithData} from "@/helpers/functional";

export default {
  components: {
    ControlUnit,
  },
  setup() {
    const widgetButtonAnimation = 'widget-button-animation';
    const store = useStore();

    const widget_button_animation = computed( {
      get() {
        return store.state.control.widget_button_animation;
      },
      set(val){
        changeHandler({
          type: widgetButtonAnimation,
          value: val,
        })
      }
    });

    const { changeControlHandler } = useStateController();

    const { setRouteTypeValue, getRouterQueryValue } =
      useRouteController('Control');

    const changeHandler = runAllWithData(
      changeControlHandler,
      setRouteTypeValue
    );

    onMounted(() => {
      changeControlHandler({
        type: widgetButtonAnimation,
        value: getRouterQueryValue(widgetButtonAnimation),
      });
    });

    return {
      widgetButtonAnimation,
      widget_button_animation,
      changeHandler,
    };
  },
};
</script>

<style lang="scss" scoped>
.input-checkbox {
  $this: 'input-checkbox';
  font-size: 14px;
  display: flex;
  align-items: center;

  &:not(:last-child) {
    margin-bottom: 5px;
  }

  &__input {
    margin-right: 8px;
  }
}
</style>
